export const ALL_APPS_AGG_ID = 'expandAppIds("*")';

export const ALL_EXTENSION_APPS_AGG_ID = 'expandAppIds("extension")';
